import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchMediaFile from "./fetchMediaFile";
/**
 * Redux wrapper around {@link fetchMediaFile} for later slice wiring. Prefer
 * `fetchMediaFile` / `useMediaFileDetails` for request-scoped loads.
 */
// eslint-disable-next-line import/prefer-default-export -- Folder thunks join this file in a later milestone.
export const getMediaFileById = createAsyncThunk("viewMedia/getMediaFileById", async (id, thunkAPI) => {
    const result = await fetchMediaFile({ id, signal: thunkAPI.signal });
    if (result.status === "success") {
        return result.file;
    }
    throw thunkAPI.rejectWithValue(result);
});
